<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title"><span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span> - Shop</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="description">
              Sparen Sie sich die aufwendige Suche nach dem passenden Ersatzteil!
              <br>
              Bei AutoEdge 24 kümmern wir uns darum: Sie nennen uns einfach Ihre Fahrzeugdaten - wir übernehmen den Rest.
            </h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 carousel-container">
            <el-carousel :height="carouselHeight" autoplay>
              <el-carousel-item>
                <img class="d-block" src="img/welcome_1.jpg" alt="First slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/welcome_2.jpg" alt="Second slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/welcome_3.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/welcome_4.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/welcome_5.jpg" alt="Third slide" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Jetzt kontaktieren und ein unverbindliches Angebot anfordern<br>
              <n-button type="primary" round @click="openWhatsapp()">
                <span class="mdi mdi-whatsapp"></span> +49 176 55980480
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@autoedge24.de
              </n-button>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto text-center">
            <!--<h2 class="title">Wir arbeiten mit:</h2>-->
            <img src="img/brands.jpeg" alt="Brands" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'shop',
  bodyClass: 'shop-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  data() {
    return {
      carouselHeight: "300px",
    };
  },
  methods: {
    onResize() {
      const carouselContaner = document.getElementsByClassName("carousel-container")[0];
      let carouselWidth = carouselContaner.clientWidth
      carouselWidth = Math.min(carouselWidth, 800)
      this.carouselHeight = (carouselWidth / 1.5) + 'px'
    },
    openPhone: function() {
      window.location = "tel:+4917655980480";
    },
    openWhatsapp: function() {
      window.open("https://wa.me/4917655980480", "_blank");
    },
    openEmail: function() {
      window.location = "mailto:kontakt@autoedge24.de";
    }
  }
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}
.carousel-container {
  max-width: 800px !important;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
